import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class MedicoService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'medicos';
  }

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'medicos'
  }

  listarComProjecao(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/comProjecao`);
  }

  listarMedicosComRelacaoMinimaDePlanoSaude(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comRelacaoMinimaDePlanoSaude`);
  }

  atualizaRelacaoMedicoPlanoSaude(value: any): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}/relacaoMedicoPlanoSaude`, value);
  }

}
